
import { getVideoInfo } from "@/utils/videoUtils";

interface VideoPlayerProps {
  src: string;
  className?: string;
  controls?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
}

export const VideoPlayer = ({ 
  src, 
  className = "w-full h-full", 
  controls = true,
  autoPlay = false,
  muted = false 
}: VideoPlayerProps) => {
  if (!src) {
    return (
      <div className={`${className} bg-black/20 rounded-lg flex items-center justify-center`}>
        <span className="text-white/60 text-sm">No hay video disponible</span>
      </div>
    );
  }

  const videoInfo = getVideoInfo(src);

  if (videoInfo.type === 'youtube' && videoInfo.embedUrl) {
    return (
      <iframe
        src={`${videoInfo.embedUrl}${autoPlay ? '?autoplay=1' : ''}`}
        className={className}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube video player"
      />
    );
  }

  // Para videos directos
  return (
    <video 
      src={videoInfo.originalUrl} 
      controls={controls}
      autoPlay={autoPlay}
      muted={muted}
      className={className}
      preload="metadata"
    >
      Tu navegador no soporta el elemento de video.
    </video>
  );
};
